import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store/Store";
import { QuoteProvider } from "./contexts/QuoteContext";
import { ChatProvider } from "./contexts/ChatContext";
import Spinner from "./views/spinner/Spinner.jsx";
import "./utils/i18n";
import "./app.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <BrowserRouter>
        <QuoteProvider>
          <ChatProvider>
            <App />
          </ChatProvider>
        </QuoteProvider>
      </BrowserRouter>
    </Suspense>
  </Provider>,
);
